import { Injectable } from '@angular/core';
import { CommonService } from 'src/@services/common.service';
import { ReportsApiClient } from 'src/@shared/shared/api-clients';
import { EndPoints } from 'src/@shared/shared/enum';

@Injectable({
  providedIn: 'root',
})
export class ReportsDomainService {
  constructor(
    private commonService: CommonService,
    private reportsApiClient: ReportsApiClient
  ) {}

  getSummary(siteId: any) {
    return this.reportsApiClient.getSummary(siteId);
  }

  getResources() {
    return this.commonService.API_GET(
      EndPoints.GetResourceRecords +
        `?startPosition=${1}&pageSize=${-1}&sortOrder=${'asc'}&sortField=${'OrderNo'}&resourceType=${0}`,
      false
    );
  }

  getLast24Months(siteId: any) {
    return this.commonService.API_GET(EndPoints.GetLast24Months + `?siteId=${siteId}`, false);
  }

  getAccountStatements(siteId: any, year: any, month: any) {
    return this.reportsApiClient.getAccountStatements(siteId, year, month);
  }

  getOutstandingInvoices(siteId: any) {
    return this.reportsApiClient.getOutstandingInvoices(siteId);
  }

  getActivityExport(siteId: any, startPeriod: any, endPeriod: any) {
    const hd = this.commonService.GetAuthorizationHeader();
    return this.commonService.API_GET(
      EndPoints.GetActivityExport +
        `?SiteId=${siteId}&StartPeriod=${startPeriod}&EndPeriod=${endPeriod}&SortOrder=desc&SortField=createdOn`,
      false,
      {
        responseType: 'blob',
        headers: hd,
      }
    );
  }

  getProgramReport(siteId: any, includeTagCategory: boolean) {
    const hd = this.commonService.GetAuthorizationHeader();
    return this.commonService.API_GET(
      EndPoints.GetProgramReport + `?SiteId=${siteId}&IncludeTagCategory=${includeTagCategory}`,
      false,
      {
        responseType: 'blob',
        headers: hd,
      }
    );
  }

  getInvestmentProgramReport(siteId: string) {
    const hd = this.commonService.GetAuthorizationHeader();
    return this.commonService.API_GET(
      EndPoints.GetInvestmentProgramReport + `?SiteId=${siteId}`,
      false,
      {
        responseType: 'blob',
        headers: hd,
      }
    );
  }

  getSiteProjection(siteId: string, calendarYear: number) {
    const hd = this.commonService.GetAuthorizationHeader();
    return this.commonService.API_GET(
      `${EndPoints.GetSiteProjection}?siteId=${siteId}&calendarYear=${calendarYear}`,
      false,
      { headers: hd }
    );
  }

  getSiteProjectionMeta(siteId: string, calendarYear: number) {
    const hd = this.commonService.GetAuthorizationHeader();
    return this.commonService.API_GET(
      `${EndPoints.GetSiteProjectionMeta}?siteId=${siteId}&calendarYear=${calendarYear}`,
      false,
      { headers: hd }
    );
  }

  getSiteProjectionBilling(siteId: string, calendarYear: number) {
    const hd = this.commonService.GetAuthorizationHeader();
    return this.commonService.API_GET(
      `${EndPoints.GetSiteProjectionBilling}?siteId=${siteId}&calendarYear=${calendarYear}`,
      false,
      { headers: hd }
    );
  }

  updateSiteForecast(requestBody: {
    siteId: string;
    calendarYear: number;
    forecastAmount: number;
  }) {
    const hd = this.commonService.GetAuthorizationHeader();
    return this.commonService.API_PUT(EndPoints.UpdateSiteForecast, requestBody, false, {
      headers: hd,
    });
  }

  getInvestmentActivityByCalendarYearExport(
    siteId: string,
    calendarYear: number | string,
    startPeriod: string,
    endPeriod: string
  ) {
    const hd = this.commonService.GetAuthorizationHeader();
    const yearParam = encodeURIComponent(String(calendarYear));
    return this.commonService.API_GET(
      EndPoints.GetInvestmentActivityByCalendarYearExport +
        `?SiteId=${siteId}&CalendarYear=${yearParam}&StartPeriod=${startPeriod}&EndPeriod=${endPeriod}`,
      false,
      {
        responseType: 'blob',
        headers: hd,
      }
    );
  }
}
